<p-button
  icon="fas fa-clipboard"
  [rounded]="true"
  [text]="true"
  [pTooltip]="l('::Evaluate')"
  tooltipPosition="right"
  (onClick)="onClick()" />
